
import React, { Component } from 'react'
import './modals.css'
import { browserHistory } from 'react-router'
import { Modal, ModalFooter, ModalBody } from './modals'

export default class UpgradeModal extends Component {
  constructor() {
    super()
  }

  render() {
    const { isOpen, dispatch, darkMode, noTrial } = this.props

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => this.props.onClose()}
            className="app-modal toolarge-modal"
            title=""
            darkMode={darkMode}
        >
            <a href="" onClick={() => browserHistory.push(`/upgrade?src_internal=${this.props.srcInternal}`)}>
            <div className="toolarge-modal-tab">
                {noTrial ? 'UPGRADE TO PRO' : 'TRY PRO FREE'}
            </div>
            </a>
            <ModalBody>           
            <div className="toolarge-modal-content">
                <div className="toolarge-modal-content-header">{this.props.header}</div>
                <div>{this.props.subheader}</div>
                <img src={`//statics.streamable.com/static/rocket${darkMode ? '-dark' : ''}.png`} />
            </div>
            </ModalBody>
            <ModalFooter>
            <button
                className="close-button"
                onClick={() => this.props.onClose()}
            >Maybe Later</button>
            <button
                className="blue-button"
                onClick={() => {
                    this.props.onClose()
                    browserHistory.push(`/upgrade?src_internal=${this.props.srcInternal}`)
                }}
            >{noTrial ? 'Upgrade Now' : 'Start Free Trial'}</button>
            </ModalFooter>
        </Modal>
    )
  }
}

